import classNames from 'clsx';
import React, { useContext, useEffect } from 'react';

import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import { useWidgetTheme } from '@swf/poker';

import PrizePlayerProvider from '../../../providers/PrizePlayerProvider';
import type { GameTypeName } from '../../../types/Game';

import PrizeDistributionModalContent from './Content/PrizeDistributionModalContent';
import Header from './Header/Header';
import styles from './shared.scss';

export interface SearchParams {
  isFlash: boolean;
  gameType: GameTypeName;
  scriptId: number;
  buyIn: string;
  promoRef: string;
}

const PrizeDistributionModal: React.FC = () => {
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { className } = useWidgetTheme();

  useEffect(() => {
    setStyle({
      overlayClassName: classNames(className, styles.modalOverlay),
      className: classNames(styles.modalContainer, styles.modalContainerCentered),
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  return (
    <>
      <Header />
      <PrizePlayerProvider>
        <PrizeDistributionModalContent />
      </PrizePlayerProvider>
    </>
  );
};

export default PrizeDistributionModal;
